<div class="d-flex align-items-center flex-wrap mb-1" style="gap: 8px">
  <button type="button" class="btn btn-outline-secondary" (click)="goBack()">Retour</button>
  <h4 class="mb-0">Config réassort — {{ entrepotLabel }}</h4>
  <button
    type="button"
    class="btn btn-primary ml-auto"
    (click)="saveDirty()"
    [disabled]="saving || loading"
  >
    {{ saving ? 'Enregistrement…' : 'Enregistrer' }}
  </button>
</div>

<p class="text-muted small">
  Seuils min/max pour ce <strong>magasin cible</strong>.
  Le stock part des entrepôts source réassort (départ) vers ce magasin lorsque le stock est sous le seuil.
  Les entrepôts source n’ont pas de configuration min/max.
</p>

<div class="row g-2 align-items-end mb-1">
  <div class="col-md-3">
    <label class="small mb-0">Recherche</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="searchTerm"
      (ngModelChange)="applySearch()"
      placeholder="Réf. / nom…"
    />
  </div>
  <div class="col-md-2">
    <label class="small mb-0">Appliquer min</label>
    <input type="number" class="form-control" [(ngModel)]="bulkMin" min="0" step="1" />
  </div>
  <div class="col-md-2">
    <label class="small mb-0">Appliquer max</label>
    <input type="number" class="form-control" [(ngModel)]="bulkMax" min="0" step="1" />
  </div>
  <div class="col-auto">
    <button type="button" class="btn btn-outline-primary" (click)="applyBulkToFiltered()">
      Appliquer à la liste filtrée
    </button>
  </div>
</div>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Réf.</th>
          <th>Nom</th>
          <th style="width: 120px">Min</th>
          <th style="width: 120px">Max</th>
          <th style="width: 100px">Stock dispo.</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="5">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading" [class.table-warning]="row.dirty">
          <td>{{ row.reference }}</td>
          <td>{{ row.nom }}</td>
          <td>
            <input
              type="number"
              class="form-control form-control-sm"
              [ngModel]="row.min_stock"
              (ngModelChange)="onMinChange(row, $event)"
              min="0"
              step="1"
            />
          </td>
          <td>
            <input
              type="number"
              class="form-control form-control-sm"
              [ngModel]="row.max_stock"
              (ngModelChange)="onMaxChange(row, $event)"
              min="0"
              step="1"
            />
          </td>
          <td>{{ row.stockDispo }}</td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="5">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="d-flex align-items-center justify-content-between flex-wrap mt-1 reasort-config-pager" *ngIf="!loading && serverTotal > 0">
  <div class="d-flex align-items-center flex-wrap" style="gap: 12px">
    <label class="mb-0 small d-flex align-items-center" style="gap: 8px">
      Afficher
      <select
        class="form-control form-control-sm"
        style="width: auto; min-width: 90px"
        [ngModel]="pageSize"
        (ngModelChange)="onPageSizeChange($event)"
      >
        <option *ngFor="let n of pageSizeOptions" [ngValue]="n">{{ n }}</option>
      </select>
    </label>
    <span class="text-muted small">{{ pageRangeLabel }} — page {{ currentPage }} / {{ totalPages }}</span>
  </div>
  <div class="d-flex align-items-center" style="gap: 6px">
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      (click)="onPageChange(-1)"
      [disabled]="currentPage <= 1"
    >
      Précédent
    </button>
    <input
      type="number"
      class="form-control form-control-sm text-center"
      style="width: 64px"
      [ngModel]="currentPage"
      (keyup.enter)="goToPage($any($event.target).value)"
      (blur)="goToPage($any($event.target).value)"
      min="1"
      [max]="totalPages"
    />
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      (click)="onPageChange(1)"
      [disabled]="currentPage >= totalPages"
    >
      Suivant
    </button>
  </div>
</div>
